import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchConToken } from '../helpers/fetch';

export const useSubscriptions = () => {
  const { empresa, role } = useSelector(state => state.auth);
  const isAdmin = role === 'ADMIN_ROLE' || role === 'SUPERADMIN_ROLE';
  const empresaId = typeof empresa === 'string' ? empresa : empresa?._id;

  const [loading, setLoading] = useState(true);
  const [suscripciones, setSuscripciones] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAdmin && !empresaId) {
      setLoading(false);
      return;
    }

    let isMounted = true;

    const cargar = async () => {
      try {
        const url = isAdmin ? 'suscripciones' : `suscripciones/empresa/${empresaId}`;
        const res = await fetchConToken(url);
        const body = await res.json();

        if (!isMounted) return;

        if (body.ok) {
          const lista = body.suscripcion ? [body.suscripcion] : body.suscripciones;
          setSuscripciones(lista);
        } else {
          setError(body.msg || 'Error cargando suscripciones');
        }
      } catch (err) {
        if (isMounted) setError('Error de conexión');
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    cargar();

    return () => {
      isMounted = false;
    };
  }, [empresaId, isAdmin]);

  return { loading, error, suscripciones };
};
